import { Brukerrolle } from '../../../models';
import { client } from '../../client';
import { SubEntityRequestService } from '../subEntityRequestService';

export default class AutorisasjonService extends SubEntityRequestService<Brukerrolle>
{
    constructor() {
        super('identitet', 'autorisasjon');
    }
    clear = async (baseId: string) => client.delete<void>(`${this.getBaseRoute(baseId)}/clear`);
}